import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { MSISDNValidationCSSStyleImpl } from './msisdnvalidationcss';
import { MSISDNValidationViewImpl } from './msisdnvalidationview';

export interface MSISDNValidationComponentProps extends UIComponentProps
{
    headerTitle:string;
    closePopup():void;
    showPopup(id:string):void;
}

export interface MSISDNValidationComponentHandler extends UIComponentHandler
{
    onConfirmClick():void;
    onClosePopup():void;
  
}
export class MSISDNValidationComponent extends UIComponentImpl<MSISDNValidationComponentProps, UIComponentState, UIDataModel> implements MSISDNValidationComponentHandler
{
    constructor(props: MSISDNValidationComponentProps)
    {
        super(props);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MSISDNValidationViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new MSISDNValidationCSSStyleImpl(applicationContext);
    }

    onConfirmClick():void
    {
        if(this.getView().validate())
        {
            this.props.context.setUserContext(this.props.context.getUserContext());
            //api calling
            this.props.showPopup(this.getContext().getResources().getString(Strings.otp_verification));

        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
       
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
         
     
    }
    onClosePopup():void
    {
        this.props.closePopup();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/msisdnvalidation/msisdnvalidationcomponent.tsx